import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import styled from 'styled-components';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Flex)`
  padding: ${themeSpace(8)} ${themeSpace(7)};
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: ${themeSpace(9)};
  ${themeMediaQuery('md')} {
    padding: ${themeSpace(8)} ${themeSpace(12)};
  }
  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding: ${themeSpace(8)} 0;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  max-width: 629px;
  ${themeMediaQuery('lg')} {
    max-width: none;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 50%;
  height: auto;
  ${themeMediaQuery('below_sm')} {
    width: 75%;
  }
`;
